import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./app/casehero/shared/components/ErrorBoundary";
import LoadingProvider from "./app/casehero/shared/providers/LoadingProvider";
import ThemeProvider from "./app/casehero/shared/providers/ThemeProvider";
import init from "./init";

// Initialise logger, Cognito, disable React Dev Tools
init();

const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <LoadingProvider>
        <Router>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </Router>
      </LoadingProvider>
    </ErrorBoundary>
  </StrictMode>
);
